import React, {useMemo, useState} from 'react';

import styles from './App.module.scss';
import logo from './assets/logo-web.png';
import {RouteNames, RouterContainer} from './components/RouterContainer';
import {IRouterContext, QuobisServiceProvider, RouterProvider} from './providers/Context.providers';
import envService from './services/EnvService';
import quobisService from './services/QuobisService';

function App(): JSX.Element {
	const hasLogo = envService.HAS_LOGO;
	const [route, setRoute] = useState<IRouterContext['route']>(RouteNames.LOGIN);
	const routerValue = useMemo(() => ({route, setRoute}), [route]);

	return (
		<div className={styles.App}>
			{
				hasLogo ?
					<img src={logo} alt="logo" className={styles.logo}/>
					:
					null
			}

			<RouterProvider value={routerValue}>
				<QuobisServiceProvider value={quobisService} >
					<RouterContainer />
				</QuobisServiceProvider>
			</RouterProvider>
		</div>
	);
}

export default App;
